import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import usePageTitle from '@/hooks/usePageTitle';
import ButtonsSection from '@/sections/Support/ButtonsSection';
import FAQSection from '@/sections/Support/FAQSection';
import { FAQS } from '@/sections/Support/utils';

const Support = () => {
  usePageTitle('Preguntas frecuentes');

  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const [faqs, setFaqs] = useState(FAQS(navigate));
  const theme = useTheme();

  useEffect(() => {
    if (filter === 'all') {
      setFaqs(FAQS(navigate));
    } else {
      const filteredFaqs = FAQS(navigate).filter((faq) => faq.category === filter);
      setFaqs(filteredFaqs);
    }
  }, [filter]);

  const handleClickFilter = (pFilter: string) => {
    if (pFilter === filter) {
      setFilter('all');
      return;
    }
    setFilter(pFilter);
  };

  return (
    <Box display="flex" flexDirection="column" gap="3rem">
      <Typography variant="h4" color={theme.palette.secondary.main}>
        Preguntas frecuentes
      </Typography>
      <ButtonsSection setFilter={handleClickFilter} filter={filter} />

      <FAQSection faqs={faqs} />
    </Box>
  );
};

export default Support;
